import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

import LoadingOverlay from "react-loading-overlay";
LoadingOverlay.propTypes = undefined;

function Maintenance(props) {
  const history = useHistory();
  const location = useLocation();

  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    const intervalIDValue = setInterval(() => {
      fetchData();
    }, 3000);

    return () => {
      clearInterval(intervalIDValue);
    };
  }, []);

  const fetchData = () => {
    fetch("/api/v1/version/maintenance", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => {
        if (!response.ok) return null;
        return response.json();
      })
      .then((actualData) => {
        if (
          actualData &&
          actualData.status == "200" &&
          !actualData.error_code
        ) {
          history.push({ pathname: "/auth/login" });
        }
      })
      .catch((err) => {
        console.log("Type:", typeof err.message);
        console.log("Message:", JSON.stringify(err.message));
        console.log("Error:", err);

        history.push({ pathname: "/auth/login" });
      });
  };

  return (
    <>
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Server restart in progress"
          className={showLoading ? "loading" : ""}
        />
      </div>
    </>
  );
}

export default Maintenance;
